import FontAwesome from 'react-fontawesome';
import HeaderLogo from './headerLogo'
import T from 'i18n-react';
import AccountSettingsDropdown from './accountSettingsDropdown'

const HeaderDesktop = props => {

    const handleButtonClick = (action) => {
        if (props.buttonHandler && props.appInitialized) {
            props.buttonHandler(action)
        }
    }

    const handleLangClick = (lang) => {
        if (props.langHandler) {
            props.langHandler(lang)
        }
    }

    var headerButtons = [];
    var headerStyle = "headerButtonStyle headerButtonMarginDesktop"
    if (!props.appInitialized) {
        headerStyle += " uninitialized"
    }

    if (props.loginComplete) {
        if (props.pathname && !props.pathname.startsWith('/register')) {
            headerButtons.push(
                <div className="headerButtonStyle headerButtonMarginDesktop" key="settingsButton"
                    onClick={(ev) => { handleButtonClick('settings') }}>
                    <FontAwesome className='fa-user' name='fa-user' size='lg' style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0)', color: '#14AA40', align: 'center' }} />
                    <span className="headerButtonTextStyle"><T.span text={{ key: 'HeaderMenuBar.labels.AccountSettings' }} /></span>
                </div>
            )
        }
        headerButtons.push(
            <div className="headerButtonStyle headerButtonMarginDesktop" key="logoutButton"
                onClick={(ev) => { handleButtonClick('logout') }}>
                <FontAwesome className='fa-sign-out' name='fa-sign-out' size='lg' style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0)', color: '#14AA40', align: 'center' }} />
                <span className="headerButtonTextStyle">{T.translate('HeaderMenuBar.labels.SignOut')}</span>
            </div>
        )
    } else {
        headerButtons.push(
            <div className={headerStyle} key="loginButton"
                onClick={(ev) => { handleButtonClick('login') }}>
                <FontAwesome className='fa-user' name='fa-user' size='lg' style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0)', align: 'center' }} />
                <span className="headerButtonTextStyle">{T.translate('Common.SignIn')}</span>
            </div>
        )
    }

    var enLangButtonStyle = 'languageButton'
    var frLangButtonStyle = 'languageButton'
    if (props.lang === 'fr') {
        enLangButtonStyle += ' unselected'
        frLangButtonStyle += ' selected'
    } else {
        enLangButtonStyle += ' selected'
        frLangButtonStyle += ' unselected'
    }

    return (
        <div className='headerStyleWF'>
            <div className="headerDesktopContainer">
                <div className="headerDesktopInnerContainer">
                    <div className="headerLeft desktopMarginLeft">
                        <HeaderLogo loaded={props.loaded} height='28px' width='161px' darkText onClick={() => handleButtonClick('home')} layoutType={props.layoutType} />
                    </div>
                    <div className="headerRight desktopMarginRight">
                        {props.loaded && 
                            <AccountSettingsDropdown 
                                lang={props.lang} 
                                langHandler={props.langHandler} 
                                loginComplete={props.loginComplete}
                                handleButtonClick={handleButtonClick}
                                pathname={props.pathname}
                                layoutType={props.layoutType} 
                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
export default HeaderDesktop;